'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var TextField = require('@material-ui/core/TextField');
var IconButton = require('@material-ui/core/IconButton');
var InputAdornment = require('@material-ui/core/InputAdornment');
var SearchIcon = require('@material-ui/icons/SearchRounded');
var CloseIcon = require('@material-ui/icons/CloseRounded');
var useDebounce = require('../useDebounce/useDebounce.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var TextField__default = /*#__PURE__*/_interopDefaultLegacy(TextField);
var IconButton__default = /*#__PURE__*/_interopDefaultLegacy(IconButton);
var InputAdornment__default = /*#__PURE__*/_interopDefaultLegacy(InputAdornment);
var SearchIcon__default = /*#__PURE__*/_interopDefaultLegacy(SearchIcon);
var CloseIcon__default = /*#__PURE__*/_interopDefaultLegacy(CloseIcon);

var _excluded = ["value", "onChange", "delay", "shouldGrowOnFocus"];
function SearchField(_ref) {
  var {
    value: valueFromProps,
    onChange,
    delay = 250,
    shouldGrowOnFocus = false
  } = _ref,
      textFieldProps = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var [inputValue, setInputValue] = React__namespace.useState('');
  var [isFocused, setIsFocused] = React__namespace.useState(false);

  function handleFocus(event) {
    var _textFieldProps$onFoc;

    setIsFocused(true);
    textFieldProps === null || textFieldProps === void 0 ? void 0 : (_textFieldProps$onFoc = textFieldProps.onFocus) === null || _textFieldProps$onFoc === void 0 ? void 0 : _textFieldProps$onFoc.call(textFieldProps, event);
  }

  function handleBlur(event) {
    var _textFieldProps$onBlu;

    setIsFocused(false);
    textFieldProps === null || textFieldProps === void 0 ? void 0 : (_textFieldProps$onBlu = textFieldProps.onBlur) === null || _textFieldProps$onBlu === void 0 ? void 0 : _textFieldProps$onBlu.call(textFieldProps, event);
  }

  function handleChange(event) {
    setInputValue(event.target.value);
  }

  function handleClear() {
    setInputValue('');
  } // Synchroize local input value with changes in props value.


  React__namespace.useEffect(() => {
    setInputValue(valueFromProps);
  }, [valueFromProps]); // Update the onChange handler when the input changes after a debounce.

  var debouncedInputValue = useDebounce.useDebounce(inputValue, delay);
  React__namespace.useEffect(() => {
    if (valueFromProps !== debouncedInputValue) {
      onChange(debouncedInputValue);
    }
  }, [valueFromProps, debouncedInputValue, onChange]);
  return /*#__PURE__*/React__namespace.createElement(TextField__default['default'], _rollupPluginBabelHelpers['extends']({}, textFieldProps, {
    fullWidth: !shouldGrowOnFocus ? undefined // rely on theme default
    : isFocused,
    value: inputValue,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onChange: handleChange,
    InputProps: _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, textFieldProps.InputProps), {}, {
      startAdornment: /*#__PURE__*/React__namespace.createElement(InputAdornment__default['default'], {
        position: "start"
      }, /*#__PURE__*/React__namespace.createElement(SearchIcon__default['default'], null)),
      endAdornment: Boolean(inputValue) && /*#__PURE__*/React__namespace.createElement(InputAdornment__default['default'], {
        position: "end"
      }, /*#__PURE__*/React__namespace.createElement(IconButton__default['default'], {
        onClick: handleClear
      }, /*#__PURE__*/React__namespace.createElement(CloseIcon__default['default'], null)))
    })
  }));
}
SearchField.propTypes = {
  value: index.string,
  onChange: index.func,
  delay: index.number
};

exports.SearchField = SearchField;
